import { InjectionToken } from '@angular/core';

import { GovernanceFacade } from './governance.facade';

export const GOVERNANCE_FACADE = new InjectionToken<GovernanceFacade>(
  'GOVERNANCE_FACADE'
);